import { IS_AU, jewlr_t } from "helpers/application"
import { instantGiftVideoData as getInstantGiftVideoData } from "helpers/holiday"

const getTitleFolder = () => (IS_AU() ? "au/" : "na/")

const mothersDayData = () => {
  const titleFolder = getTitleFolder()
  return {
    style: {
      left: {
        desktop: "19%",
        tablet: "3%",
        widescreen: "12%",
      },
      px: 2,
      top: {
        _: "10%",
        tablet: "50%",
      },
      width: {
        _: "100%",
        desktop: "375px",
        tablet: "400px",
        widescreen: "430px",
      },
    },
    texts: [
      {
        alt: "Instant Gift For Mom",
        fallback: `${require(`images/instant-gifts/explained/main_banner/mothersday/${titleFolder}title.svg`)}`,
        srcSet: [
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/mothersday/${titleFolder}title_mobile.svg`)}`,
          },
          {
            media: "(min-width: 768px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/mothersday/${titleFolder}title.svg`)}`,
          },
        ],
        style: {
          mb: 2,
          width: {
            _: "250px",
            tablet: "95%",
          },
        },
        type: "image",
      },
      {
        style: {
          fontSize: {
            _: "20px",
            tablet: "22px",
          },
          letterSpacing: "normal",
          light: false,
          mb: 0,
        },
        text: "Order Today, Share Right Away!",
        type: "description",
      },
    ],
  }
}

const mothersDay2024Data = () => {
  const titleFolder = getTitleFolder()
  return {
    style: {
      left: "auto",
      px: {
        _: "14%",
        tablet: 2,
      },
      right: {
        _: "0",
        desktop: "5%",
        tablet: "0%",
        widescreen: "2%",
      },
      top: {
        _: "14%",
        tablet: "50%",
      },
      width: {
        _: "100%",
        desktop: "56%",
        tablet: "50%",
        widescreen: "60%",
      },
    },
    texts: [
      {
        alt: `An Instant Gift for ${jewlr_t(
          "terms.Mom"
        )} - Order Today, Share Right Away!`,
        fallback: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_desktop.svg`)}`,
        srcSet: [
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_mobile.svg`)}`,
          },
          {
            media: "(min-width: 768px) and (max-width: 1023px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_tablet.svg`)}`,
          },
          {
            media: "(min-width: 1024px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_desktop.svg`)}`,
          },
        ],
        style: {
          maxWidth: {
            _: "100%",
            xlarge: "140%",
          },
          width: {
            _: "100%",
            desktop: "87%",
            tablet: "95%",
            xlarge: "140%",
          },
        },
        type: "image",
      },
    ],
  }
}

const genericData = () => ({
  style: {
    left: {
      tablet: "18%",
    },
    px: 2,
    top: {
      _: "10%",
      tablet: "50%",
    },
    width: {
      _: "100%",
      desktop: "450px",
      tablet: "350px",
    },
  },
  texts: [
    {
      style: {
        fontSize: {
          _: 26,
          tablet: 30,
        },
        fontWeight: 500,
        mb: 0,
      },
      text: "Instant Gift",
      type: "title",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: 0,
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
  ],
})

const holidayData = () => ({
  style: {
    left: "auto",
    px: {
      _: 5,
      tablet: 2,
    },
    py: 0,
    textAlign: "center",
    top: {
      _: "20%",
      tablet: "50%",
    },
    width: "100%",
  },
  textBlockStyle: {
    mx: "auto",
    width: {
      tablet: "420px",
    },
  },
  texts: [
    {
      alt: "Instant Gift",
      fallback: require("images/instant-gifts/explained/main_banner/holiday/instant_gift.svg"),
      srcSet: [
        {
          media: "(max-width: 1279px)",
          sizes: "100vw",
          srcSet: require("images/instant-gifts/explained/main_banner/holiday/instant_gift.svg"),
        },
        {
          media: "(min-width: 1280px)",
          sizes: "100vw",
          srcSet: require("images/instant-gifts/explained/main_banner/holiday/instant_gift.svg"),
        },
      ],
      style: {
        mb: 2,
        ratio: "4 / 1",
        width: {
          _: "230px",
          widescreen: "320px",
        },
      },
      type: "image",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: {
          _: 2,
          widescreen: 3,
        },
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        mb: 0,
      },
      text: `The perfect last-minute gifting solution! Create and
      purchase a meaningful, ${jewlr_t("terms.personalized")} gift,
      and have it sent virtually to a loved one using our Instant
      Gift video option. Your actual gift arrives a${" "}
      <span className="nowrap">few days later.</span>`,
      type: "description",
    },
  ],
})

const valentinesData = () => ({
  style: {
    left: "auto",
    textAlign: "center",
    top: {
      _: "30%",
      tablet: "50%",
    },
    width: "100%",
  },
  textBlockStyle: {
    mx: "auto",
    width: {
      _: "75%",
      tablet: "400px",
    },
  },
  texts: [
    {
      style: {
        as: "h1",
        color: "#D14275",
        fontSize: 30,
        fontWeight: 700,
        mb: 1,
      },
      text: "Instant Gift",
      type: "title",
    },
    {
      style: {
        bold: true,
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: {
          _: 2,
          widescreen: 3,
        },
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: 0,
      },
      text: `The perfect last-minute gifting solution! Create and
      purchase a meaningful, ${jewlr_t("terms.personalized")}${" "}
      gift, and have it sent virtually to a loved one using our
      Instant Gift video option. Your actual gift arrives a${" "}
      <span className="nowrap">few days later.</span>`,
      type: "description",
    },
  ],
})

const fathersdayData = () => ({
  style: {
    left: {
      desktop: "18%",
      tablet: "7%",
    },
    px: 2,
    top: {
      _: "10%",
      tablet: "50%",
    },
    width: {
      _: "100%",
      desktop: "450px",
      tablet: "350px",
    },
  },
  texts: [
    {
      style: {
        fontSize: {
          _: 26,
          tablet: 30,
        },
        fontWeight: 500,
        mb: 0,
      },
      text: "Instant Gift",
      type: "title",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: 0,
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
  ],
})

export const instantGiftData = () => {
  let textareaData = genericData()
  const instantGiftVideoData = getInstantGiftVideoData()
  const bgImgFolder = instantGiftVideoData.main_banner
  const mainBannerFolder = instantGiftVideoData.main_banner_folder

  let mainBannerStyle = {
    pb: {
      _: "121.2%",
      desktop: "22.76%",
      tablet: "43.28%",
    },
  }

  if (instantGiftVideoData.main_banner === "mothersday") {
    textareaData = mothersDayData()
  } else if (instantGiftVideoData.main_banner === "holiday") {
    textareaData = holidayData()
  } else if (instantGiftVideoData.main_banner === "valentines") {
    textareaData = valentinesData()
  } else if (instantGiftVideoData.main_banner === "fathersday") {
    textareaData = fathersdayData()
  } else if (instantGiftVideoData.main_banner?.startsWith("2024-mothers-day")) {
    textareaData = mothersDay2024Data()
    mainBannerStyle = {
      pb: {
        _: "94.52%",
        desktop: "19.53%",
        tablet: "36.62%",
      },
    }
  }

  const mainBanner = mainBannerFolder
    ? {
        alt: "Instant Gift - Order today, share right away!",
        desktop_2x: `${sl.config.jewlr_asset_url}${mainBannerFolder}/desktop_2x.jpg`,
        srcSet: [
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${sl.config.jewlr_asset_url}${mainBannerFolder}/mobile.jpg 767w,
      ${sl.config.jewlr_asset_url}${mainBannerFolder}/mobile_2x.jpg 1534w`,
          },
          {
            media: "(min-width: 768px) and (max-width: 1023px)",
            sizes: "100vw",
            srcSet: `${sl.config.jewlr_asset_url}${mainBannerFolder}/tablet.jpg 1005w,
      ${sl.config.jewlr_asset_url}${mainBannerFolder}/tablet_2x.jpg 2010w`,
          },
          {
            media: "(min-width: 1024px)",
            sizes: "100vw",
            srcSet: `${sl.config.jewlr_asset_url}${mainBannerFolder}/desktop.jpg 1920w,
      ${sl.config.jewlr_asset_url}${mainBannerFolder}/desktop_2x.jpg 3840w`,
          },
        ],
      }
    : {
        alt: "Instant Gift - Order today, share right away!",
        desktop_2x: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/desktop_2x.jpg`)}`,
        srcSet: [
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/mobile.jpg`)} 767w,
   ${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/mobile_2x.jpg`)} 1534w`,
          },
          {
            media: "(min-width: 768px) and (max-width: 1023px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/tablet.jpg`)} 1005w,
   ${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/tablet_2x.jpg`)} 2010w`,
          },
          {
            media: "(min-width: 1024px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/desktop.jpg`)} 1920w,
   ${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/desktop_2x.jpg`)} 3840w`,
          },
        ],
      }

  return {
    image: mainBanner,
    style: {
      mb: 0,
      ...mainBannerStyle,
    },
    textarea: textareaData,
  }
}
